import React from 'react';
import Canvas from './components/Canvas';
import './App.css';

function App() {
  return (
    <div className="App">
      <Canvas />
    </div>
  );
}

export default App;